/**
 * This confirmation modal is taking the props expected by the OCCs UI ConfirmationModal
 * but it is implemented using our PromptModal component to have a consistent
 * look and feel across the application.
 *
 * You may also wish to use this modal if you need the buttons to be disabled when an 'isAccepting' prop is true
 */

import type { ConfirmationModalProps } from '@vista-digital/occ-ui/'
import type { FC } from 'react'
import type { PromptModalProps } from '../prompt/PromptModal'
import { PromptModal } from '../prompt/PromptModal'

export const ConfirmationModal: FC<ConfirmationModalProps> = (props: ConfirmationModalProps) => {
    const {
        show,
        className,
        anchoredToTop,
        mode,
        canBeClosed,
        footerLayout,
        children,
        message,
        heading,
        templateParameters,
        acceptLabel,
        onAccept,
        isAccepting,
        cancelLabel,
        onCancel,
        secondaryActionLabel,
        onSecondaryAction,
    } = props

    const promptModalProps: PromptModalProps = {
        show,
        className,
        canBeClosed,
        children,
        title: heading,
        richText: message,
        primaryButtonProps: {
            label: acceptLabel,
            onClick: onAccept,
            disabled: isAccepting,
        },
        secondaryButtonProps: secondaryActionLabel
            ? {
                  label: secondaryActionLabel,
                  onClick: onSecondaryAction,
                  disabled: isAccepting,
              }
            : undefined,
        cancelButtonProps: cancelLabel
            ? {
                  label: cancelLabel,
                  onClick: onCancel,
                  disabled: isAccepting,
              }
            : undefined,
        mode,
        anchoredToTop,
        templateParameters,
        footerLayout,
        onClose: onCancel,
    }

    return <PromptModal {...promptModalProps} />
}
